module.exports = __webpack_public_path__ + "img/registered.1119380d.svg";